<template>
  <div class="stack stack--small">
    <template v-if="status === 'listing-documents'">
      <template v-if="container.type === 'binder'">
        Načítám dokumenty v šanonu <em>{{ container.label }}</em>…
      </template>
      <template v-else-if="container.type === 'tray'">
        Načítám dokumenty v odkladači…
      </template>
    </template>
    <template v-else-if="status === 'documents-listed'">
      <template v-if="documents.length > 0">
        <SelectionGroup
          v-model="selectedLocal"
          type="checkbox"
          name="documents"
          label="Vyberte dokumenty"
          :options="documentsRadioOptions"
          :disabled="importedKeys"
        />
      </template>
      <template v-else>
        <template v-if="container.type === 'binder'">
          Šanon <em>{{ container.label }}</em> je prázdný
        </template>
        <template v-else-if="container.type === 'tray'">
          Odkladač je prázdný
        </template>
      </template>
    </template>
    <template v-else-if="status === 'container-access-denied'">
      <template v-if="container.type === 'binder'">
        Do šanonu <em>{{ container.label }}</em> nemáte přístup
      </template>
      <template v-else-if="container.type === 'tray'">
        Do odkladače nemáte přístup
      </template>
    </template>
    <template v-else-if="status === 'something-wrong'">
      Něco se pokazilo, ozvěte se nám prosím
    </template>
  </div>
</template>

<script>
import SelectionGroup from '@/components/SelectionGroup';

import DocumentManager from '@/mixins/DocumentManager';

export default {
  name: 'DocumentsSelectionList',
  model: {
    prop: 'selected',
    event: 'change',
  },
  components: {
    SelectionGroup,
  },
  mixins: [
    DocumentManager,
  ],
  props: {
    apiToken: {
      type: String,
    },
    container: {
      type: Object,
    },
    selected: {
      type: [String, Array],
      default() {
        return [];
      },
    },
    imported: {
      type: Object,
      default() {
        return {};
      },
    },
    failed: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      status: null,
      documents: [],
      selectedLocal: [],
    };
  },
  computed: {
    importedKeys() {
      return Object.keys(this.imported);
    },
    documentsRadioOptions() {
      const options = this.documents.map((document) => {
        let labelSecondary;
        let flat = true;
        if (this.failed[document.id]) {
          const intro = '👎&emsp;Nepodařilo se importovat fakturu';
          const errors = this.failed[document.id].invoice.error;
          const formattedErrors = errors.map((item) => `<li>${item.message}</li>`);
          labelSecondary = `
            ${intro}
            <ul>
              ${formattedErrors.join()}
            </ul>
          `;
          flat = false;
        } else if (this.imported[document.id]) {
          if (this.imported[document.id]?.company?.created) {
            labelSecondary = '<span title="Firma nebyla nalezena v adresáři a byla založena nová">🏢</span>&emsp;👍';
          } else {
            labelSecondary = '👍';
          }
        } else {
          labelSecondary = `<a href="${document.url}" target="_blank" title="Otevřít v Document Manageru" style="font-size: 0.8rem;">→ DM</a>`;
        }
        return {
          id: document.id,
          label: document.title || '<em>(dokument bez názvu)</em>',
          labelSecondary,
          flat,
        };
      });
      return options;
    },
  },
  watch: {
    status() {
      this.$emit('status-change', { status: this.status, data: this.$data });
    },
    selected() {
      this.selectedLocal = this.selected;
    },
    selectedLocal() { this.onSelectedChange(); },
    container() {
      this.listDocuments();
    },
  },
  methods: {
    async listDocuments() {
      try {
        this.status = 'listing-documents';
        const documents = await this.$_DocumentManager_listAllDocuments({
          token: this.apiToken,
          container: this.container,
        });
        this.documents = documents;
        this.status = 'documents-listed';
      } catch (error) {
        if (error.response.status === 403) {
          this.status = 'container-access-denied';
        } else {
          this.status = 'something-wrong';
          throw error;
        }
      }
    },
    onSelectedChange() {
      this.$emit('change', this.selectedLocal);
    },
  },
  mounted() {
    this.listDocuments();
  },
  beforeDestroy() {
    this.documents = [];
    this.selectedLocal = [];
    this.onSelectedChange();
  },
};
</script>
